/*
 * Copyright (C) 2005 - 2023. Cloud Software Group, Inc. All Rights Reserved. Confidential & Proprietary.
 * Licensed pursuant to commercial Cloud Software Group, Inc. End User License Agreement.
 */

export default {
    FULL_DATA: 'full',
    SAMPLE_DATA: 'sample',
    NO_DATA: 'nodata'
};
